<template>
  <div>
    <div class="product2">
      <div class="productBanner">
        <div class="module">
          <div class="h1">ZTMapEasy</div>
          <div class="line"></div>
          <div class="h2">2.5D-GIS平台</div>
          <div class="p">提供了2.5D地图渲染及数据切片处理能力，同时实现了与传统二维GIS地图的无缝整合能力</div>
        </div>
        <div class="img"></div>
      </div>
      <div class="overview">
        <div class="module">
          <div class="productTitle">
            概述
            <span>/Overview</span>
          </div>
          <div
            class="p"
          >臻图ZTMapEasy是专为2.5D（亦称假三维）地图渲染和应用开发研发的轻量级GIS产品。该产品提供了2.5D地图渲染及数据切片处理能力，同时实现了与传统二维GIS地图的无缝整合能力。并提供丰富的常用开发接口，简化基于2.5D地图的应用开发难度和流程。</div>
        </div>
      </div>
      <div class="function">
        <div class="productTitle">
          功能简介
          <span>/Function</span>
        </div>
        <div class="functionbg">
          <div class="module">
            <div class="list">
              <div>
                <div class="left">01</div>
                <div class="right">
                  <div class="title">地图数据渲染</div>
                </div>
              </div>
              <div>
                <div class="left">02</div>
                <div class="right">
                  <div class="title">地图数据切片</div>
                </div>
              </div>
              <div>
                <div class="left">03</div>
                <div class="right">
                  <div class="title">地图对象标绘</div>
                </div>
              </div>
              <div>
                <div class="left">04</div>
                <div class="right">
                  <div class="title">地图事件定义</div>
                </div>
              </div>
              <div>
                <div class="left">05</div>
                <div class="right">
                  <div class="title">业务属性挂接</div>
                </div>
              </div>
              <div>
                <div class="left">06</div>
                <div class="right">
                  <div class="title">二维地图无缝集成</div>
                </div>
              </div>
              <div>
                <div class="left">07</div>
                <div class="right">
                  <div class="title">互联网地图整合</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rendering">
        <div class="module">
          <div class="productTitle">
            效果图
            <span>/Rendering</span>
          </div>
          <div class="list">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <div class="characteristics">
        <div class="module">
          <div class="productTitle">
            技术特点
            <span>/Characteristics</span>
          </div>
          <div class="list">
            <div>
              <div class="title">跨平台渲染</div>
              <div class="p">支持PC、手机、大屏、微信等各种形态终端</div>
            </div>
            <div>
              <div class="title">轻量化渲染</div>
              <div class="p">数据处理优化，数据量小，效率高</div>
            </div>
            <div>
              <div class="title">多级缓存机制</div>
              <div class="p">保证浏览用户体验</div>
            </div>
            <div>
              <div class="title">应用开发接口丰富</div>
              <div class="p">封装众多常用应用接口，降低应用开发难度</div>
            </div>
            <div>
              <div class="title">数据制作和渲染应一体化</div>
              <div class="p">从数据制作和渲染应用，一体化机制</div>
            </div>
            <div>
              <div class="title">架构开放</div>
              <div class="p">兼容第三方地图平台</div>
            </div>
          </div>
        </div>
      </div>
      <div class="application">
        <div class="module">
          <div class="productTitle">
            行业应用
            <span>/Application</span>
          </div>
          <div class="list">
            <div>
              智慧园区
              <div class="c">A</div>
            </div>
            <div>
              智慧安防
              <div class="c">B</div>
            </div>
            <div>
              智慧社区
              <div class="c">C</div>
            </div>
            <div>
              智慧环保
              <div class="c">D</div>
            </div>
            <div>
              公共安全
              <div class="c">E</div>
            </div>
            <div>
              应急指挥
              <div class="c">F</div>
            </div>
            <div>
              指挥场馆
              <div class="c">G</div>
            </div>
            <div>
              智慧建筑
              <div class="c">H</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-product2">
      <div class="product-title">
        <div class="title-content">
          <div class="title">ZTMapEasy</div>
          <div class="line"></div>
          <div class="p">
            2.5D-GIS平台
          </div>
          <div class="span">
            提供了2.5D地图渲染及数据切片处理能力，同时实现了与传统二维GIS地图的无缝整合能力
          </div>
        </div>
        <div class="img">
          <img src="../../assets/images/index/banner_img2.png" alt="">
        </div>
      </div>
      <div class="part">
        <div class="part-title">概述</div>
        <div class="en-title">OVERVIEW</div>
        <div class="overview-content">
          臻图ZTMapEasy是专为2.5D（亦称假三维）地图渲染和应用开发研发的轻量级GIS产品。该产品提供了2.5D地图渲染及数据切片处理能力，同时实现了与传统二维GIS地图的无缝整合能力。并提供丰富的常用开发接口，简化基于2.5D地图的应用开发难度和流程。
        </div>
      </div>
      <div class="characteristics">
        <div class="part-title">功能简介</div>
        <div class="en-title">FUNCTION</div>
        <div class="content">
          <div class="item">
            <div>
              <p>01</p>
              <span>地图数据渲染</span>
            </div>
            <div>
              <p>02</p>
              <span>地图数据切片</span>
            </div>
            <div>
              <p>03</p>
              <span>地图对象标绘</span>
            </div>
            <div>
              <p>04</p>
              <span>地图事件定义</span>
            </div>
            <div>
              <p>05</p>
              <span>业务属性挂接</span>
            </div>
            <div>
              <p>06</p>
              <span>二维地图无缝集成</span>
            </div>
            <div>
              <p>07</p>
              <span>互联网地图整合</span>
            </div>
          </div>
        </div>
      </div>
      <div class="rendering">
        <div class="part-title">效果图</div>
        <div class="en-title">RENDERING</div>
        <div class="swiper">
          <el-carousel class="case-carousel" indicator-position="outside" height="23rem" >
            <el-carousel-item v-for=" index in 4" :key="index">
              <img :src="getImg(`product2-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="part function">
        <div class="part-title">技术特点</div>
        <div class="en-title">CHARACTERISTICS</div>
        <div class="content">
          <div class="item" v-for="item in functionList" :key="item.id">
            <p>{{ item.title }}</p>
            <span>{{ item.content }}</span>
          </div>
        </div>
      </div>
 
      
      <div class="part">
        <div class="part-title">行业应用</div>
        <div class="en-title">APPLICATION</div>
        <div class="application-content">
          <div class="item item1">智慧园区</div>
          <div class="item item2">智慧安防</div>
          <div class="item item3">智慧社区</div>
          <div class="item item4">智慧环保</div>
          <div class="item item5">公共安全</div>
          <div class="item item6">应急指挥</div>
          <div class="item item7">指挥场馆</div>
          <div class="item item8">智慧建筑</div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Product2",
  metaInfo: {
    title:
      "2.5D-GIS平台_2.5D地图引擎_假三维地图系统_假三维GIS引擎_ZTMapEasy-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content:
          "2.5D-GIS,2.5DGIS,假三维GIS,假三维地图,倾斜45度三维地图"
      },
      {
        name: "description",
        content:
          "ZTMapEasy是专为2.5D（亦称假三维）地图渲染和应用开发研发的轻量级GIS产品。该产品提供了2.5D地图渲染及数据切片处理能力,同时实现了与传统二维GIS地图的无缝整合能力。并提供丰富的常用开发接口,简化基于2.5D地图的应用开发难度和流程。"
      }
    ]
  },
  data() {
    return {
      functionList: [
        {
          id: 1,
          title: '跨平台渲染',
          content: '支持PC、手机、大屏、微信等各种形态终端'
        },
        {
          id: 2,
          title: '轻量化渲染',
          content: '数据处理优化，数据量小，效率高'
        },
        {
          id: 3,
          title: '多级缓存机制',
          content: '保证浏览用户体验'
        },
        {
          id: 4,
          title: '应用开发接口丰富',
          content: '封装众多常用应用接口，降低应用开发难度'
        },
        {
          id: 5,
          title: '数据制作和渲染应一体化',
          content: '从数据制作和渲染应用，一体化机制'
        },
        {
          id: 6,
          title: '架构开放',
          content: '兼容第三方地图平台'
        },
      ],
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/product/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.productBanner {
  .img {
    background-image: url("../../assets/images/index/banner_img2.png");
  }
}
.product2 {
  .overview {
    margin-bottom: 100px;
  }
  .function {
    margin-top: 100px;
    .productTitle {
      text-align: center;
      margin-bottom: 40px;
    }
    .functionbg {
      background: url("../../assets/images/product/bg3.png") no-repeat top
        center / cover;
      .list {
        font-size: 0;
        padding-bottom: 68px;
        > div {
          display: inline-block;
          width: 25%;
          padding-top: 68px;
          vertical-align: top;
          .left {
            font-size: 40px;
            color: rgba(223, 223, 223, 1);
            float: left;
          }
          .right {
            padding-left: 60px;
            .title {
              font-size: 20px;
              color: rgba(75, 75, 75, 1);
              line-height: 46px;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
  .characteristics {
    height: 777px;
    background: url("../../assets/images/product/bg4.png") no-repeat top center /
      cover;
    overflow: hidden;
    margin-bottom: 100px;
    .productTitle {
      text-align: center;
      margin: 70px 0 40px 0;
    }
    .list {
      font-size: 0;
      > div {
        display: inline-block;
        width: 380px;
        height: 250px;
        background: #fff;
        margin-right: 24px;
        margin-bottom: 24px;
        box-shadow: 0px 0px 60px 10px rgba(13, 37, 62, 0.1);
        border-radius: 5px;
        text-align: center;
        vertical-align: top;
        padding: 0 50px;
        box-sizing: border-box;
        .title {
          font-size: 24px;
          color: rgba(2, 118, 247, 1);
          margin: 50px 0 20px 0;
        }
        .p {
          font-size: 20px;
          color: rgba(124, 124, 124, 1);
          line-height: 28px;
        }
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
  .rendering {
    padding: 100px 0 150px 0;
    .productTitle {
      text-align: center;
      margin: 0 0 40px 0;
    }
    .list {
      font-size: 0;
      > div {
        width: 590px;
        height: 383px;
        background: #ccc;
        display: inline-block;
        margin-bottom: 20px;
        background: no-repeat center center / 100% 100%;
        &:nth-child(1) {
          background-image: url("../../assets/images/product/product2-1.jpg");
        }
        &:nth-child(2) {
          background-image: url("../../assets/images/product/product2-2.jpg");
        }
        &:nth-child(3) {
          background-image: url("../../assets/images/product/product2-3.jpg");
        }
        &:nth-child(4) {
          background-image: url("../../assets/images/product/product2-4.jpg");
        }
        &:nth-child(2n + 1) {
          margin-right: 20px;
        }
      }
    }
  }
  .application {
    margin-bottom: 127px;
    .productTitle {
      text-align: center;
      margin-bottom: 39px;
    }
    .list {
      font-size: 0;
      > div {
        width: 280px;
        height: 269px;
        display: inline-block;
        background: #ccc;
        margin-right: 26px;
        margin-bottom: 31px;
        vertical-align: top;
        writing-mode: lr-tb;
        font-size: 12px;
        padding: 42px 111px 0 144px;
        box-sizing: border-box;
        font-size: 30px;
        color: rgba(255, 255, 255, 1);
        line-height: 42px;
        cursor: pointer;
        position: relative;
        .c {
          position: absolute;
          font-size: 30px;
          line-height: 30px;
          bottom: 38px;
          left: 38px;
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:nth-child(1),
        &:nth-child(8) {
          background: url("../../assets/images/product/application_bg1.png")
            no-repeat center center/100% 100%;
          .c {
            color: #70b4ff;
          }
        }
        &:nth-child(2),
        &:nth-child(7) {
          background: url("../../assets/images/product/application_bg2.png")
            no-repeat center center/100% 100%;
          .c {
            color: #f895a4;
          }
        }
        &:nth-child(3),
        &:nth-child(6) {
          background: url("../../assets/images/product/application_bg3.png")
            no-repeat center center/100% 100%;
          .c {
            color: #ffd28e;
          }
        }
        &:nth-child(4),
        &:nth-child(5) {
          background: url("../../assets/images/product/application_bg4.png")
            no-repeat center center/100% 100%;
          .c {
            color: #a8efa3;
          }
        }
      }
    }
  }
}
.mobile-product2 {
  display: none;
  flex-direction: column;
  font-family: 'Normal';
  .product-title {
    width: 100%;
    height: 28rem;
    background: linear-gradient(180deg, #3374EF 0%, #9DCFFF 100%);
    box-sizing: border-box;
    padding: 8rem 0 0 2rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    color: white;
    .title-content {
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .line {
        width: 4rem;
        height: 0.2rem;
        background: #FFFFFF;
        margin-top: 1rem;
      }
      .p {
        font-size: 1.4rem;
        font-weight: 500;
        line-height: 2rem;
        margin-top: 2rem;
      }
      .span {
        width: 15rem;
        margin-top: 1rem;
        font-size: 1rem;
        font-weight: 350;
        line-height: 1.6rem;
      }
    }
    .img {
      flex-grow: 1;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }
  .part {
    box-sizing: border-box;
    padding: 2rem;
    text-align: center;
    font-family: 'Normal';
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
  }
  .part {
    box-sizing: border-box;
    padding: 2rem;
    text-align: center;
    font-family: 'Normal';
    .overview-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .overview-content {
      font-size: 1rem;
      font-weight: 350;
      line-height: 2rem;
      color: #3D3D3D;
      text-align: left;
      text-indent: 2em;
      margin-top: 2rem;
      color: #333333;
    }
  }
  .function {
    background-image: url('../../assets/images/product/bg1.png');
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
    .content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      box-sizing: border-box;
      .item {
        width: 47.5%;
        box-sizing: border-box;
        padding: 2rem 1.5rem 1.5rem 1.5rem;
        background: rgba(255, 255, 255, 0.5);
        font-family: 'Normal';
        margin-top: 1.5rem;
        text-align: left;
        >p {
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 2rem;
          text-align: center;
        }
        >span {
          font-size: 1rem;
          font-weight: 350;
          line-height: 1.5rem;
          margin-top: 2rem;
          color: #333333;
          
        }
      }
    }
  }
  .rendering {
    text-align: center;
    font-family: 'Normal';
    box-sizing: border-box;
    padding: 2rem 0;
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .swiper {
      margin-top: 2rem;
    }
  }
  .characteristics {
    background-image: url('../../assets/images/product/bg1.png');
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-family: 'Normal';
    box-sizing: border-box;
    padding: 2rem;
    height: 27rem;
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .content {
      width: 100%;
      box-sizing: border-box;
      padding-top: 2rem;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 0 0.5rem;
        margin-top: 1rem;
        div {
          width: 50%;
          display: flex;
          align-items: center;
          >p {
            font-size: 1.2rem;
            font-weight: bold;
            color: #999999;
          }
          >span {
            margin-left: 1rem;
            font-size: 1rem;
            font-weight: 350;
            color: #333333;
          }
        }
      }
    }
  }
  .part {
    .application-content {
      width: 100%;
      height: 25rem;
      margin-top: 2rem;
      font-family: 'Normal';
      position: relative;
      margin-left: -1rem;
      .item {
        width: 9.5rem;
        height: 9.5rem;
        clip-path: polygon(25% 0%, 75% 0%, 100% 44%, 75% 88%, 25% 88%, 0% 44%);
        font-size: 1.4rem;
        font-weight: bold;
        line-height: 8.36rem;
        text-align: center;
        color: #fff;
      }
      .item1 {
        background: rgba(60, 128, 232, 0.5);
        position: absolute;
        top: 0;
        left: 0;
      }
      .item2 {
        background: rgba(60, 128, 232, 0.8);
        position: absolute;
        top: 0;
        left: 50%;
      }
      .item3 {
        background: rgba(60, 128, 232, 0.6);
        position: absolute;
        top: 20%;
        left: 25%;
      }
      .item4 {
        background: rgba(60, 128, 232, 0.7);
        position: absolute;
        top: 20%;
        left: 75%;
      }
      .item5 {
        background: rgba(60, 128, 232, 0.4);
        position: absolute;
        top: 37.5%;
        left: 0%;
      }
      .item6{
        background: rgba(60, 128, 232, 0.5);
        position: absolute;
        top: 37.5%;
        left: 50%;
      }
      .item7 {
        background: rgba(60, 128, 232, 0.7); 
        position: absolute;
        top: 57.5%;
        left: 25%; 
      }
      .item8 {
        background: rgba(60, 128, 232, 0.8); 
        position: absolute;
        top: 57.5%;
        left: 75%; 
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .productBanner {
    display: none !important;
  }
  .product2 {
    display: none;
  }
  .mobile-product2 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/product/product2.vue